angular.module('statWdressroom', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/stat-wdressroom/stat-wdressroom.module.js